import type { DeepPartial } from '@luna/utils-ts';

import type { MoneyAutomationFeatures } from './MoneyAutomationFeatures';

export const SK: DeepPartial<MoneyAutomationFeatures> = {};
